module.exports = __webpack_public_path__ + "img/demo-design-bites.a08123b4.png";